module.exports = __webpack_public_path__ + "static/D365-advanced-supply-chain-management-d2ce9355f44563d3a725e5f57bc0c968.png";